import * as Sentry from '@sentry/react';

// Sentry context for self-service SMB signup is allow-listed: only the keys
// below are forwarded. Anything not on this list — including PII like email,
// payment-method ids, and OTP tokens — is dropped silently.
const ALLOW_LIST: ReadonlySet<string> = new Set([
  'idempotency_key',
  'contract_id',
  'stripe_customer_id',
  'stripe_subscription_id',
  'trial_days_granted',
  'step',
  'substep',
  'flow_kind',
  'billing_interval',
]);

export function scrubSelfServiceSMBSignupContext(
  input: Record<string, unknown>
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(input)) {
    if (!ALLOW_LIST.has(key)) continue;
    out[key] = value;
  }
  return out;
}

// Scrubbed Sentry capture for the self-service SMB signup flow. Always route
// captures here so the PII allow-list filter is the single boundary — never
// call Sentry.captureException directly with raw tags from this flow.
export function captureSelfServiceError(err: unknown, context: Record<string, unknown>): void {
  Sentry.captureException(err, {
    tags: scrubSelfServiceSMBSignupContext({
      flow_kind: 'self_serve',
      ...context,
    }) as Record<string, string>,
  });
}
